import { TagView } from '@api-proxies';
import { TagService } from '@http/clients/tag.service';
import { EntityTypes } from '@models/enums/EntityTypes';
import { IComponentEditorEntity } from '../../entity-interfaces/editor-entity.interface';

export abstract class TagEntity<TEntityDestination> implements IComponentEditorEntity<TagView, TEntityDestination> {
    constructor(readonly tagService: TagService) {}

    abstract toDestination(entity: TagView): TEntityDestination;

    abstract toSource(entity: TEntityDestination): TagView;

    abstract getSource(entityType?: EntityTypes, filterText?: string): Promise<TagView[]>;
}
